module.exports = __webpack_public_path__ + "static/media/landline.c413ad8e.svg";